import React from 'react';
import { motion } from 'framer-motion';
import { LayoutDashboard, Wrench, Activity, MonitorCog } from 'lucide-react';
export function PortalSlide() {
  return <div className="h-full w-full flex flex-col items-center justify-start px-4 md:px-8 bg-[#11166b] relative overflow-y-auto py-12 md:py-6" data-id="element-99">
      {/* Background grid effect */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1a2080_1px,transparent_1px),linear-gradient(to_bottom,#1a2080_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20 pointer-events-none" data-id="element-100" />

      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center mb-4 md:mb-6 relative z-10 mt-4 md:mt-0" data-id="element-101">
        <div className="inline-flex items-center justify-center p-2 bg-[#00d8a8]/10 rounded-xl mb-3 md:mb-4" data-id="element-102">
          <LayoutDashboard className="w-6 h-6 md:w-8 md:h-8 text-[#00d8a8]" data-id="element-103" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-104">
          Management Portal
        </h2>
        <p className="text-sm md:text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-105">
          Complete visibility and control over your entire charging
          infrastructure.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 max-w-6xl w-full relative z-10" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-[#0d1155]/80 backdrop-blur-sm border border-[#1a2080] p-4 md:p-5 rounded-2xl" data-id="element-107">
          <Wrench className="w-5 h-5 md:w-6 md:h-6 text-[#00d8a8] mb-2 md:mb-3" data-id="element-108" />
          <h3 className="text-base md:text-lg font-bold text-white mb-1" data-id="element-109">
            Remote Management
          </h3>
          <p className="text-xs md:text-sm text-slate-300" data-id="element-110">
            Manage installations remotely without needing physical access.
            Configure settings and troubleshoot instantly.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-[#0d1155]/80 backdrop-blur-sm border border-[#1a2080] p-4 md:p-5 rounded-2xl" data-id="element-111">
          <Activity className="w-5 h-5 md:w-6 md:h-6 text-[#00d8a8] mb-2 md:mb-3" data-id="element-112" />
          <h3 className="text-base md:text-lg font-bold text-white mb-1" data-id="element-113">
            Deep Insights
          </h3>
          <p className="text-xs md:text-sm text-slate-300" data-id="element-114">
            Get a unified view of charger activity and home energy use for
            deeper insights into customer behaviour. No more switching
            platforms.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-[#0d1155]/80 backdrop-blur-sm border border-[#1a2080] p-4 md:p-5 rounded-2xl" data-id="element-115">
          <MonitorCog className="w-5 h-5 md:w-6 md:h-6 text-purple-400 mb-2 md:mb-3" data-id="element-116" />
          <h3 className="text-base md:text-lg font-bold text-white mb-1" data-id="element-117">
            Prevent Site Visits
          </h3>
          <p className="text-xs md:text-sm text-slate-300" data-id="element-118">
            Drastically reduce on-site maintenance visits. Diagnose and fix
            issues from your desk.
          </p>
        </motion.div>
      </div>

      {/* Portal Screenshot */}
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6,
      duration: 0.8
    }} className="mt-4 md:mt-6 w-full max-w-5xl relative mb-24 md:mb-0 flex-1 min-h-0" data-id="element-119">
        <div className="relative rounded-t-2xl border-t border-x border-[#1a2080] overflow-hidden shadow-2xl" data-id="element-120">
          <img src="https://cdn.magicpatterns.com/uploads/fwMyUxhpjNZRNp7RU9oxRA/portal.png" alt="Management Portal Interface" className="w-full h-auto" data-id="element-121" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#11166b] pointer-events-none" data-id="element-122" />
        </div>
      </motion.div>
    </div>;
}